<template>
  <div class="container" style="background:#fff;padding:0px;">
      <topOp> </topOp>
      <div class="row">
        <div class="col-md-12">
          <div class="horasExtras">
            <h3 style="font-style:italic;font-weight: 700;">
              Adicional Noturno
            </h3>
           <div class="formAjuste" >
             <div style="cursor:pointer; width:19px;height:19px;background: #F7B733 ;position:relative;top:386px;left:378px;border-radius:40px; " v-b-popover.hover.right="'- Informar o valor do salário contratual recebido mensalmente.' " >
              <span style="color:#fff;margin-top:10px;font-weight:bold;position: relative;
    top: -3px;">?</span>
              </div> 
              <div style="cursor:pointer; width:19px;height:19px;background: #F7B733 ;position:relative;top:455px;left:378px;border-radius:40px; " v-b-popover.hover.right="'- Informar a carga horária semanal.\n A jornada normal do empregado urbano, rural ou doméstico, quando a lei ou a norma coletiva de trabalho não definir outro limite, pode ser contratada até o limite de 44 horas semanais e de 8 horas diárias. (Constituição Federal, art. 7°, inc. XIII).' " >
              <span style="color:#fff;margin-top:10px;font-weight:bold;position: relative;
    top: -3px;">?</span>
              </div>    
              <div style="cursor:pointer; width:19px;height:19px;background: #F7B733 ;position:relative;top:522px;left:378px;border-radius:40px; " v-b-popover.hover.right="'- Valor calculado automaticamente pelo sistema.\n\n  Corresponde à divisão do salário mensal pela jornada de trabalho mensal. Exemplo: R$ 1.500,00 / 220 h = R$ 6,82' " >
              <span style="color:#fff;margin-top:10px;font-weight:bold;position: relative;
    top: -3px;">?</span>
              </div>    
              <div style="cursor:pointer; width:19px;height:19px;background: #F7B733 ;position:relative;top:590px;left:378px;border-radius:40px; " v-b-popover.hover.right="'- A hora noturna deve ser paga com um acréscimo de, no mínimo, 20% (vinte por cento) sobre o valor da hora diurna na atividade urbana e de 25% (vinte e cinco por cento) na atividade rural. (CLT, art. 73; Lei 5.889/73, art. 7º). \n\n Deverá ser observada, se houver, previsão mais benéfica ao empregado em Acordo Coletivo, Convenção Coletiva ou Sentença Normativa.'" >
              <span style="color:#fff;margin-top:10px;font-weight:bold;position: relative;
    top: -3px;">?</span>
              </div>        
             <p style="text-align:left;margin-bottom:-11px;padding:0px;">Mês/Ano<p>  
             <label class="sr-only" >Mes</label>  
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text " ><i class="fa fa-calendar" style="color:#808080;"></i></div>
                </div>
                <input type="text" class="form-control formatacaoInput" maxlength="7" v-model="mesAno" placeholder="MM/AAAA">
              </div>
              <p style="text-align:left;margin-bottom:-11px;padding:0px;">Horas adicional Noturno<p>             
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text "><i class="material-icons" style="font-size:16px;color:#808080;">access_time</i></div>
                </div>
                <input type="text" class="form-control formatacaoInput" v-model="horasAdicionalNoturno">
              </div>
              <p style="text-align:left;margin-bottom:-11px;padding:0px;">Nº de feriados do mês<p>                           
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text "><i class="fa fa-calendar-check-o" style="color:#808080;"></i></div>
                </div>                
                <input type="text" v-model="feriadosMes" class="form-control formatacaoInput">
              </div>
              <p style="text-align:left;margin-bottom:-11px;padding:0px;">Salário Mensal<p>             
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text "><i class="material-icons" style="font-size:16px;color:#808080;">attach_money</i></div>
                </div>
                 <money  class="form-control formatacaoInput" v-model="salario" v-bind="money" @keydown.native="$event.key === '-' ? $event.preventDefault() : null"></money> 
              </div>
              <p style="text-align:left;margin-bottom:-11px;padding:0px;">Jornada Semanal<p>             
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text "><i class="material-icons" style="font-size:16px;color:#808080;">access_time</i></div>
                </div>
                <input type="text" class="form-control formatacaoInput" v-model="jornadaSemanal">
              </div>
              <p style="text-align:left;margin-bottom:-11px;padding:0px;">Valor Hora<p>            
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text "><i class="material-icons" style="font-size:16px;color:#808080;">attach_money</i></div>
                </div>
                <input  class="form-control formatacaoInput" v-model="valorHora" disabled/> 
              </div>
              <p style="text-align:left;margin-bottom:-11px;padding:0px;">% Adicional<p>           
              <div class="input-group mb-3 mr-sm-2">
                <div class="input-group-prepend">
                  <div class="input-group-text "><i class='fas fa-percentage' style="color:#808080;"></i></div>
                </div>
                <money  class="form-control formatacaoInput" v-model="adicional" v-bind="porcentagem"></money>
              </div>
              <div  v-if="exibirCheck" class="form-group mb-4 mr-sm-2" style="text-align:left;margin-top:16px;">                  
                <div @click="exibirCheck = !exibirCheck" style="width: 25px; cursor:pointer; 
height: 25px;border: 1px solid #707070;display:inline-block;border-radius:5px;margin-bottom:6px;"><i class="fa fa-check"  style="font-size:17px;margin-left:3px;"></i></div> Calcular DRS                  
              </div>
              <div @click="exibirCheck = !exibirCheck" v-else class="form-group mb-4 mr-sm-2" style="text-align:left;margin-top:16px;"> 
                <div style="width: 25px; cursor:pointer;
height: 25px;border: 1px solid #707070;display:inline-block;border-radius:5px;"></div> <span style="position:relative;top:-6px;">Calcular DSR</span>                  
              </div>
            <button class="limpar" @click="limpar()">Limpar</button>  <a href="#horasExtrasResultado4"> <button :disabled="disabled" class="calcular" @click="calcular()" >calcular <b-spinner v-show="spiner" style="width: 1.5rem;
height: 1.5rem;" small></b-spinner></button></a>
              <br>
              <br>
              <span style="color:red;" v-show="erro">Erro no cálculo. Por favor revise os campos!</span>
              <br>
            </div>
          </div>
        </div>
      </div>
      <div class="horasExtrasResultado" id="horasExtrasResultado4"   style="background:#BEBEBE;">
            <h3 style="font-style:italic;">
              Resultado do Cálculo
            </h3>  
            <div id="formAjuste2"> 
              <!-- <p class="pResult1"> Quantidade horas adicional Noturno:</p>
              <input type="text" class="inputResult"  :value="resultadoQuantidadeHoras" disabled> -->
              <p class="pResult1"> Valor Adicional Noturno:</p>
              <input type="text" class="inputResult"  :value="resultadoAdicionalNoturno" disabled>
               <p class="pResult1"> Valor DSR:</p>
              <input type="text" class="inputResult"  :value="resultadoValorDSR" disabled>
               <p class="pResult1"> Dias Úteis:</p>
              <input type="text" class="inputResult"  :value="resultadoDiasUteis" disabled>
               <p class="pResult1"> Domingos e Feriados:</p>
              <input type="text" class="inputResult"  :value="resultadoDomingosFeriados" disabled>              
            </div>
        </div>
  </div>
</template> 

<script>
import services from '../services/services.js'
 import {Money} from 'v-money';
import topOp from '../shared/topOp.vue';
export default {  
  components:{
    'topOp':topOp,
    Money
  },
  data(){
    return {
      disabled:false,
      spiner:false,
      exibirCheck:false,
      mesAno:'',
      feriadosMes:0,
      salario:0,
      jornadaSemanal:0,
      valorHora:null,
      adicional:0,
      horasAdicionalNoturno:0,
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
         porcentagem:{
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        resultadoAdicionalNoturno:null,
        resultadoDiasUteis:null,
        resultadoValorDSR:null,
        resultadoDomingosFeriados:null,
        resultadoQuantidadeHoras:null,
        resAdicionalNoturno:[],
        erro:false
    }
  },
  methods:{
    async calcular(){      
      this.disabled = true;
      this.spiner = true
      
      let horasNoturnasFormatadas = parseFloat(this.horasAdicionalNoturno.toString().replace(',', '.'));
      if (isNaN(horasNoturnasFormatadas)) {
        horasNoturnasFormatadas = 0;
      }
      horasNoturnasFormatadas = Math.round(horasNoturnasFormatadas * 100).toString();

      this.resAdicionalNoturno = await services.getCalcularAdicionalNoturno(this.mesAno,this.feriadosMes,this.salario,this.jornadaSemanal,this.adicional,this.exibirCheck,horasNoturnasFormatadas);
      if(this.resAdicionalNoturno == undefined){
        this.spiner = false;
        this.disabled = false;
        this.erro = true
        return;
      }    
      this.resultadoValorDSR = this.resAdicionalNoturno.dsr
      console.log('valor dsr vindo do back: ' + this.resultadoValorDSR);
      this.resultadoDiasUteis = this.resAdicionalNoturno.diasUteis
      console.log('valor dias uteis vindo do back: ' +this.resultadoDiasUteis);
      this.resultadoDomingosFeriados = this.resAdicionalNoturno.domingosFeriados
      console.log('valor domingos e feriados vindo do back: ' + this.resultadoDomingosFeriados);
      this.resultadoAdicionalNoturno = this.resAdicionalNoturno.adicionalNoturno
      console.log('valor adicional noturno vindo do back: ' + this.resultadoAdicionalNoturno);
      // this.resultadoQuantidadeHoras = parseFloat(this.resAdicionalNoturno.totalAdicionalNoturno.toString().replace(',', '.')).toFixed(2).replace('.', ',')
      this.valorHora = this.resAdicionalNoturno.valorHora;
      console.log('valor hora vindo do back: ' + this.valorHora);
      this.spiner = false;
      this.disabled = false;
      this.erro = false;
    },
    limpar(){
      this.mesAno ='';
      this.feriadosMes =0;
      this.salario = 0;
      this.jornadaSemanal = 0;
      this.valorHora = null;
      this.adicional = 0;
      this.exibirCheck = false;
      this.resultadoValorDSR = '';
      this.resultadoDiasUteis = '';
      this.resultadoDomingosFeriados = '';
      this.resultadoAdicionalNoturno = '';
      this.resultadoQuantidadeHoras = '';
      this.erro = false;
    }
  },
  watch:{
    mesAno(novo,velho){                 
        if(novo.length == 3 && !(novo[(novo.length-1)] == '/')){
            this.mesAno = this.mesAno.replace(/(\d{2})/,"$1/")
        }            
        this.mesAno= this.mesAno.replace(/[A-Za-z]/, '')         
        this.mesAno= this.mesAno.replace(/[!@#$%¨&*)(+´^>}{.,|"<;:]/, '') 
        }
  },
  mounted(){
     
  }

}
</script>

<style >
div.input-group-text{
  /* border-left: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070; */
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}
#formAjuste2{
  width: 370px;
  margin:20px auto; 
}
.inputResult{
    width: 370px;height: 45px;border-radius:10px;padding-left:10px;
}
.container-flex {        
         display: flex;
         flex-direction: row;
         justify-content: center;
         align-items: center
     }
     .box {
         width: 360px;
        height: 45px;
         background: #fff;
     }
.resultado{
  width: 407px;
height: 45px;
background: #fff;
}
.formAjuste{
  width: 370px;
  margin:0px auto;
  position: relative;
  top:-40px;
}
.pResult1{
text-align:left;margin-bottom:5px;margin-top:10px;margin-left:4px;
}
.calcular{
 float: right;background: #FF7835 0% 0% no-repeat padding-box;
border: 2px solid #FF7835;
border-radius: 5px;width: 170px;
font-size:21px;
height: 48px;color:#fff;margin-top:-10px;font-weight: 600;cursor:pointer;
font-style:italic;
}
.incluir{
  float: right;background: #FF7835 0% 0% no-repeat padding-box;
border: 2px solid #FF7835;
border-radius: 5px;width: 170px;
font-size:17px;
height: 48px;color:#fff;margin-top:-10px;font-weight: bold;cursor:pointer;
}
.calcular:hover{
  background: #e64d00;
  border:1px solid #e64d00;
}
.limpar{
  float: left;border: 2px solid #FF7835;
border-radius: 5px;background:#fff;padding:5px;font-weight: 500;font-size:15px;width: 105px;cursor:pointer;font-style:italic;
}
 
input.formatacaoInput{
  /* border-right: 1px solid #707070;
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070; */
  border-radius: 10px;
   height: 43px;
}
.horasExtrasResultado{ 
  padding-left:110px;
  padding-right:110px;
  padding-bottom:30px;
  padding-top:30px;
}
.horasExtras{
  padding-left:110px;
  padding-right:110px;
}
h3{
  border-bottom: 1px solid #707070;
  padding-bottom: 6px;
  text-align: left;
  font-weight: bold;
  font-size:26px;
}
#formAjuste2{
  width: 370px;
  margin:20px auto;
}
input{
  border-right: 1px solid #707070;
    border-top: 1px solid #707070;
    border-bottom: 1px solid #707070;
}
@media only screen and (max-width: 767px) {
 .horasExtras{
   margin-top:445px;
 }
 #formAjuste2{
  width: 320px;
 }
}
@media only screen and (max-width: 767px) {
  #formAjuste2{
  width: 300px;
  margin:20px auto;
}
.horasExtras{
   padding-left:80px;
 }
}
@media only screen and (max-width: 400px) {
  #formAjuste2{
    width: 230px;
    margin:20px auto;
  }
  .limpar{
    width: 88px;
  }
  .calcular{
  width: 126px;
  height: 37px;
  margin-top:0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/screens/AdicionalNoturno.vue